import React, { forwardRef, memo } from 'react'

const ToolWrenchIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="28"
      height="28"
      viewBox="0 0 40 40"
      fill="none"
      {...props}>
      <path
        d="M31.25 8.75L22.5 17.5"
        stroke="#78BE20"
        strokeWidth="3.23"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6156 20.7719C11.4994 20.6558 11.4072 20.5179 11.3443 20.3662C11.2814 20.2144 11.249 20.0517 11.249 19.8875C11.249 19.7232 11.2814 19.5605 11.3443 19.4088C11.4072 19.2571 11.4994 19.1192 11.6156 19.0031L12.8656 17.7531C13.0829 17.5887 13.3479 17.4999 13.6203 17.5H16.25C16.5815 17.5 16.8995 17.3683 17.1339 17.1339C17.3683 16.8994 17.5 16.5815 17.5 16.25V13.6422C17.5002 13.3111 17.6317 12.9936 17.8656 12.7594L26.1828 4.44216C26.7983 3.82647 27.5291 3.33807 28.3334 3.00485C29.1377 2.67163 29.9997 2.50012 30.8703 2.50012C31.7409 2.50012 32.603 2.67163 33.4073 3.00485C34.2115 3.33807 34.9423 3.82647 35.5578 4.44216C36.1735 5.05767 36.6619 5.78843 36.9951 6.59273C37.3284 7.39702 37.4999 8.25908 37.4999 9.12966C37.4999 10.0002 37.3284 10.8623 36.9951 11.6666C36.6619 12.4709 36.1735 13.2017 35.5578 13.8172L27.2406 22.1344C27.0064 22.3683 26.6889 22.4998 26.3578 22.5H23.75C23.4185 22.5 23.1005 22.6317 22.8661 22.8661C22.6317 23.1005 22.5 23.4185 22.5 23.75V26.3797C22.5001 26.6521 22.4112 26.9171 22.2469 27.1343L20.9969 28.3843C20.8808 28.5006 20.7429 28.5928 20.5912 28.6557C20.4394 28.7186 20.2768 28.751 20.1125 28.751C19.9482 28.751 19.7856 28.7186 19.6338 28.6557C19.4821 28.5928 19.3442 28.5006 19.2281 28.3843L11.6156 20.7719Z"
        stroke="#78BE20"
        strokeWidth="3.23"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4219 24.5781L2.5 37.5"
        stroke="#78BE20"
        strokeWidth="3.23"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
)

ToolWrenchIcon.displayName = 'ToolWrenchIcon'

export default memo(ToolWrenchIcon)
